<script>
import axios from 'axios'

export default {
  name: 'organ',
  props: ['organ', 'frame', 'totalFrames', 'autoSelect', 'editable'],
  data () {
    return {
      data: {areaList: [], guide1: {}, guide2: {}},
      activeAreaIndex: null,
      img: {},
      canvas: {},
      context: {},
      canvasHeight: 350,
      canvasWidth: 450,

      status: null, // normal, saving, loading

      strokeStyle: 'darkgrey',
      fillStyle: '#fff',
      canvasStyle: {cursor: 'default'},
      guide1LineStyle: {},
      guide2LineStyle: {}
    }
  },
  mounted: function () {
    window.organ = this
    this.img = this.$refs.img
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    this.loadImage()
  },
  computed: {
    organBaseName () {
      return this.organ.split('.')[this.organ.split('.').length - 1]
    },
    rootDataPath () {
      return '/data'
    },
    organPath () {
      return `${this.rootDataPath}/${this.organ.replace(/\./g, '/')}`
    },
    metaDataPath () {
      return `${this.rootDataPath}/organs`
    },
    imagePath () {
      if (this.frame) {
        return `${this.organPath}/${this.frame}.jpg`
      } else {
        return `${this.organPath}/image.jpg`
      }
    },
    dataPath () {
      if (this.frame) {
        return this.organPath + `/${this.frame}.json`
      } else {
        return this.organPath + '/data.json'
      }
    },
    schematicImagePath () {
      return `${this.metaDataPath}/${this.activeArea.name}.jpg`
    },
    descriptionPath () {
      return `${this.metaDataPath}/${this.activeArea.name}.txt`
    },
    guide1Path () {
      return this.organPath + '/guide-1.jpg'
    },
    guide2Path () {
      return this.organPath + '/guide-2.jpg'
    },
    areaList () {
      return this.data.areaList
    },
    activeArea () {
      if (this.activeAreaIndex === null) {
        return {}
      }
      return this.areaList[this.activeAreaIndex] || {}
    }
  },
  watch: {
    organ (newValue) {
      this.$refs.guide1Image.style.display = ''
      this.$refs.guide2Image.style.display = ''
      this.loadDataAndRedraw()
    },
    frame (newValue) {
      this.loadDataAndRedraw()
    },
    data: {
      deep: true,
      handler () {
        this.guide1LineStyle = this.guideLineStyle(this.data.guide1)
        this.guide2LineStyle = this.guideLineStyle(this.data.guide2)
      }
    }
  },
  methods: {
    loadImage () {
      this.loadDataAndRedraw()
      let designer = this
      this.img.onload = function () {
        designer.redrawImage(designer)
      }
    },
    redrawImage (designer) {
      designer = designer || this
      let img = designer.img
      if (img.width === 0) return
      designer.canvas.width = img.width
      designer.canvas.height = img.height
      designer.canvasWidth = img.width
      designer.canvasHeight = img.height
      this.redraw()
    },
    descriptionNoCachePath () {
      return this.descriptionPath + '?_=' + new Date().getTime()
    },
    clickLocation (area) {
      let location = ''
      if (!this.organ.startsWith('/')) {
        location += '/'
      }
      location += this.organ + '.' + area.name
      if (area.frames) {
        location += area.frames
      }
      return location
    },
    onload () {

    },
    loadDataAndRedraw () {
      this.data = {areaList: [], guide1: {'x': 0}, guide2: {'x': 0}}
      let organ = this
      axios(this.dataPath).then(response => {
        organ.data = response.data
        organ.onload()
        organ.redraw()
      })
    },
    redraw () {
      this.canvasStyle.cursor = this.activeArea.name === undefined ? 'default' : this.activeArea.hasChild ? 'pointer' : 'help'
      this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      this.context.drawImage(this.img, 0, 0, this.img.width, this.img.height, 0, 0, this.canvas.width, this.canvas.height)
      this.drawAreas()
    },
    drawAreas () {
      for (let area of this.areaList) {
        if (area === this.activeArea) {
          this.drawNodes(area)
        }
        this.drawArea(area)
      }
    },
    closeArea (context, area) {
      let fillStyle = this.getAreaFillStyle(area)
      let strokeStyle = this.getAreaStrokeStyle(area)
      context.fillStyle = fillStyle
      context.fill()
      if (strokeStyle) {
        context.strokeStyle = strokeStyle
        context.stroke()
      }
      context.beginPath()
    },
    getAreaFillStyle (area) {
      return ''
    },
    getAreaStrokeStyle (area) {
      return ''
    },
    scaledPoint: function (point) {
      return {x: point.x * this.canvas.width / this.img.width,
        y: point.y * this.canvas.height / this.img.height,
        restart: point.restart}
    },
    drawArea (area) {
      let context = this.context
      context.beginPath()
      for (let point of area.points) {
        point = this.scaledPoint(point)
        if (point.restart) {
          this.closeArea(context, area)
          context.moveTo(point.x, point.y)
        } else {
          context.lineTo(point.x, point.y)
        }
      }
      this.closeArea(context, area)
    },
    selectAreaByIndex (index) {
      this.activeAreaIndex = index
      if (this.activeArea.name && !this.activeArea.description) {
        axios(this.descriptionPath).then(response => {
          this.$set(this.activeArea, 'description', this.markdown(response.data))
        })
      }
      this.redraw()
    },
    getMousePosOnRect (evt, rect) {
      // https://stackoverflow.com/questions/17130395/real-mouse-position-in-canvas
      return {
        x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * this.canvasWidth),
        y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * this.canvasHeight)
      }
    },
    getMousePos (evt) {
      let rect = this.canvas.getBoundingClientRect()
      return this.getMousePosOnRect(evt, rect)
    },
    isInside (point, pointList) {
      // ray-casting algorithm based on
      // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

      let x = point.x
      let y = point.y

      let inside = false
      for (let i = 0, j = pointList.length - 1; i < pointList.length; j = i++) {
        let xi = pointList[i].x
        let yi = pointList[i].y
        let xj = pointList[j].x
        let yj = pointList[j].y

        let intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
        if (intersect) inside = !inside
      }
      return inside
    },
    guideLineStyle (guide) {
      if (guide) {
        if (guide.x && guide.x !== 0) {
          return {'left': `${guide.x}`, 'top': '0px', 'width': '2px', 'height': '100%'}
        }
        if (guide.y && guide.y !== 0) {
          return {'left': '0', 'top': `${guide.y}`, 'width': '100%', 'height': '2px'}
        }
        return {'display': 'none'}
      }
    },
    markdown (s) {
      if (!s) {
        return s
      }
      s = s.replace(new RegExp(/\n/, 'g'), '<br />')
      s = s.replace(new RegExp(/\*\*(.*?)\*\*/, 'g'), '<span class="bold">$1</span>')
      s = s.replace(new RegExp(/\*(.*?)\*/, 'g'), '<span class="highlight">$1</span>')
      s = s.replace(new RegExp(/\[(.*)]\((.*)\)/, 'g'), '<a href="$2">$1</a>')
      console.log('markdown')
      return s
    }
  }
}
</script>
<style>
.guideLine {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gEJBwAbWBqpegAAAA1JREFUCNdj+M/B8R8ABSgCD7iP78oAAAAASUVORK5CYII=')
}
.description .highlight {
  color: #ff0000;
  background-color: #ffff99;
}
.description .bold {
  color: #e20000;
  font-weight: bold;
}
.description .link {
  color: #0000ff;
  background-color: #ffff99;
  text-decoration: underline;
  text-decoration-color: #2b669a;
}
</style>



// WEBPACK FOOTER //
// src/components/Organ.vue